import { render, staticRenderFns } from "./Chambers.vue?vue&type=template&id=3a1fe464&"
import script from "./Chambers.vue?vue&type=script&lang=js&"
export * from "./Chambers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports